import type { TDocumentosPessoa } from '@/features/enviar-documentos/interfaces'
import { HttpService } from '@/infra'

export class GetDocumentosDoCompradorDaPropostaService extends HttpService {
  execute = async (numeroDaProposta: string, pessoaId: string) => {
    return this.http.get<TDocumentosPessoa>(`/api/v2/Proposta/${numeroDaProposta}/comprador/${pessoaId}/documentos`)
  }
}
